import { Map } from 'immutable';
import * as travel from '../../actions/relocation/relocationTravel';

const initialState = Map({
    selectedBundleService: [],
    bundlesAndServices: [],
    travelTypes: [],
    relocationPurpose: [],
    travelClassTypes: [],
    dietaryRequirementTypes: [],
    relocationPlanTravelDetails: {},
    travelValidated: false,
    vehicleTypesWithCanTowAndTowable: []
})

const actionsMap = {    
    [travel.SET_SELECTED_BUNDLES_SERVICES]: (state, action) => {
        return state.set('selectedBundleService', action.data);
    },
    [travel.SET_BUNDLES_SERVICES]: (state, action) => {
        return state.set('bundlesAndServices', action.data);
    },
    [travel.SET_TRAVEL_TYPES]: (state, action) => {
        return state.set('travelTypes', action.data);
    },
    [travel.SET_RELOCATION_PURPOSE]: (state, action) => {
        return state.set('relocationPurpose', action.data);
    },
    [travel.SET_TRAVEL_CLASS_TYPES]: (state, action) => {
        return state.set('travelClassTypes', action.data);
    },
    [travel.SET_DIETARY_REQUIREMENT_TYPES]: (state, action) => {
        return state.set('dietaryRequirementTypes', action.data);
    },
    [travel.SET_RELOCATION_PLAN_TRAVEL_DETAILS]: (state, action) => {
        return state.set('relocationPlanTravelDetails', action.data);
    },
    [travel.UPDATE_TRAVEL_DETAILS_VALIDATION]: (state, action) => {
        return state.set('travelValidated', action.data);
    },
    [travel.SET_VEHICLE_TYPES_WITH_CAN_TOW_AND_TOWABLE]: (state, action) => {
        return state.set('vehicleTypesWithCanTowAndTowable', action.data);
    },
}

export default function facilities(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}